export enum Breakpoints {
  ExtraSmallMax = 'ExtraSmallMax',
  SmallMin = 'SmallMin',
  SmallMax = 'SmallMax',
  MediumMin = 'MediumMin',
  MediumMax = 'MediumMax',
  LargeMin = 'LargeMin',
  LargeMax = 'LargeMax',
  ExtraLargeMin = 'ExtraLargeMin',
  ExtraLargeMax = 'ExtraLargeMax',
  SuperExtraLargeMin = 'SuperExtraLargeMin',
}

const BREAKPOINT_VALUES: Record<Breakpoints, number> = {
  [Breakpoints.ExtraSmallMax]: 599,
  [Breakpoints.SmallMin]: 600,
  [Breakpoints.SmallMax]: 899,
  [Breakpoints.MediumMin]: 900,
  [Breakpoints.MediumMax]: 1199,
  [Breakpoints.LargeMin]: 1200,
  [Breakpoints.LargeMax]: 1535,
  [Breakpoints.ExtraLargeMin]: 1536,
  [Breakpoints.ExtraLargeMax]: 2048,
  [Breakpoints.SuperExtraLargeMin]: 2049,
};

export function isLargerThan(
  curentScreenSize: number,
  breakpiont: Breakpoints
): boolean {
  return curentScreenSize > BREAKPOINT_VALUES[breakpiont];
}

export function isSmallerThan(
  curentScreenSize: number,
  breakpiont: Breakpoints
): boolean {
  return curentScreenSize < BREAKPOINT_VALUES[breakpiont];
}
